module.exports = __webpack_public_path__ + "img/bulang.8a185fce.png";